import { ImageProps } from '@features/powerpoint';
import { rectangleOptions } from './shapes';
import {
  applyDimensionXOffset,
  applyDimensionYOffset,
} from '@features/executive-report/dimensions/layout';
import { centeredImage } from '@features/executive-report/slides/centered-image';
import { SalesDimensionsSlideBaseOptions } from './content';

export const images = (
  subdimensions: SalesDimensionsSlideBaseOptions['subdimensions']
): ImageProps[] =>
  subdimensions.flatMap((subdimension, index): ImageProps[] =>
    subdimension.image
      ? [
          centeredImage({
            image: subdimension.image,
            maxHeight: rectangleOptions.h,
            maxWidth: rectangleOptions.w,
            x: rectangleOptions.x + applyDimensionXOffset(index),
            y: rectangleOptions.y + applyDimensionYOffset(index),
          }),
        ]
      : []
  );
